export default "__VITE_ASSET__491a17b5__"